import { h } from 'preact';
import React, { Component } from 'react';

import { ImageSettings } from './ImageSettings';
import ImageSVG from './Image.svg';

import './Image.css';

export class Image extends Component {
  render() {
    const Settings = new ImageSettings(this.props.component.settings);

    const styles = {
      ...Settings.margin,
      ...Settings.border
    };

    /* WIDTH & HEIGHT */
    const { marginLeft, marginRight } = Settings.margin;
    styles.width = Settings.width.type === 'auto' ? 'auto' : Settings.width.value + Settings.width.type;
    styles.height = Settings.height.type === 'auto' ? 'auto' : Settings.height.value + Settings.height.type;
    if (Settings.width.type === '%') {
      styles.width = `calc(${Settings.width.value}% - ${(marginLeft + marginRight)}px`
    }

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }

    const className = 'message-component message-image no-children';
    return (
      <img
        alt=""
        src={Settings.url || ImageSVG}
        path={path}
        className={selected ? className + ' on-active' : className}
        style={styles}
        {...devActions}
      />
    );
  }
}
